/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

import {LitElement} from 'lit';

import {ListItemHarness} from '../../../list/internal/listitem/harness.js';
import {MenuItem} from '../controllers/menuItemController.js';

/**
 * Test harness for menu item.
 */
export class MenuItemHarness extends ListItemHarness<MenuItem & LitElement> {}
